exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actions[data-v-832d7980]{display:flex;margin-top:1rem;align-items:center;justify-content:end;width:100%;gap:.5rem}.form-process .field[data-v-832d7980]{margin-bottom:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-832d7980","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cultura/sections/configuration/Process.vue
// module id = 1527
// module chunks = 2